<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter3" id="pgepubid00002">
<h2 class="nobreak" id="CONTENTS">CONTENTS.</h2>
</div>
<table class="calibre12" id="toc" summary="">
<tbody class="calibre13"><tr class="xsmall">
<td class="calibre14"></td>
<td class="calibre14"></td>
<td class="tdr">PAGE</td>
</tr>
<tr class="calibre15">
<td class="tdr1">I.</td>
<td class="tdl"><span class="smcap">Introductory</span></td>
<td class="tdr2"><a href="#/Text/Section0004#toclink_1">1</a></td>
</tr>
<tr class="calibre15">
<td class="tdr1">II.</td>
<td class="tdl"><span class="smcap">Marlowe</span></td>
<td class="tdr2"><span href="#/Text/Section0005#toclink_28" title="Link target outside of Sample">28</span></td>
</tr>
<tr class="calibre15">
<td class="tdr1">III.</td>
<td class="tdl"><span class="smcap">Webster</span></td>
<td class="tdr2"><span href="#/Text/Section0006#toclink_55" title="Link target outside of Sample">55</span></td>
</tr>
<tr class="calibre15">
<td class="tdr1">IV.</td>
<td class="tdl"><span class="smcap">Chapman</span></td>
<td class="tdr2"><span href="#/Text/Section0007#toclink_78" title="Link target outside of Sample">78</span></td>
</tr>
<tr class="calibre15">
<td class="tdr1">V.</td>
<td class="tdl"><span class="smcap">Beaumont and Fletcher</span></td>
<td class="tdr2"><span href="#/Text/Section0008#toclink_100" title="Link target outside of Sample">100</span></td>
</tr>
<tr class="calibre15">
<td class="tdr1">VI.</td>
<td class="tdl"><span class="smcap">Massinger and Ford</span></td>
<td class="tdr2"><span href="#/Text/Section0009#toclink_113" title="Link target outside of Sample">113</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?5d04b09a